<template>
  <v-list>
    <v-tooltip right :disabled="!touchScreenDevice">
      <template v-slot:activator="{ on }">
        <v-list-item link @click="$emit('return')" v-on="on">
          <v-list-item-action>
            <img class="vis-icon" src="/img/toolbar/Return.svg" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("ReturnTooltip") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ $t("ReturnTooltip") }}</span>
    </v-tooltip>
    <v-tooltip right :disabled="!touchScreenDevice">
      <template v-slot:activator="{ on }">
        <v-list-item link @click="showHideAllPmi" v-on="on">
          <v-list-item-action>
            <img class="vis-icon" :src="showHideAllPmiIcon" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t(showHideAllPmiText) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ $t(showHideAllPmiText) }}</span>
    </v-tooltip>
    <v-tooltip right :disabled="!touchScreenDevice">
      <template v-slot:activator="{ on }">
        <v-list-item link @click="hideSelectedPmi" v-on="on" :disabled="!selectedPmi">
          <v-list-item-action>
            <img class="vis-icon" src="/img/toolbar/HidePMI.svg" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("HidePMITooltip") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ $t("HidePMITooltip") }}</span>
    </v-tooltip>
    <v-tooltip right :disabled="!touchScreenDevice">
      <template v-slot:activator="{ on }">
        <v-list-item link @click="alignSelectedPmi" v-on="on" :disabled="!selectedPmi">
          <v-list-item-action>
            <img class="vis-icon" src="/img/toolbar/AlignToView.svg" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("AlignSelectedPMITooltip") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ $t("AlignSelectedPMITooltip") }}</span>
    </v-tooltip>
    <v-tooltip right :disabled="!touchScreenDevice">
      <template v-slot:activator="{ on }">
        <v-list-item link @click="openPMIFilters" v-on="on">
          <v-list-item-action>
            <img class="vis-icon" src="/img/toolbar/Filters.svg" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("PMIFiltersTooltip") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ $t("PMIFiltersTooltip") }}</span>
    </v-tooltip>
  </v-list>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    showHideAllPmiIcon: "/img/toolbar/ShowAllPMI.svg",
    showHideAllPmiText: "ShowAllPMITooltip",
    selectedPmi: ""
  }),
  computed: {
    ...mapState(["touchScreenDevice", "pmiFiltersMap"]),
    ...mapGetters(["viewerManager", "pmiManager"])
  },
  mounted: function() {
    this.$root.$on("modelLoaded", this.refreshMenu);
  },
  methods: {
    ...mapMutations(["setSideDrawer", "setPmiActive"]),
    refreshMenu: function(psId) {
      this.showHideAllPmiIcon = "/img/toolbar/ShowAllPMI.svg";
      this.showHideAllPmiText = "ShowAllPMITooltip";
      this.resetPmiFilters();
      this.processPmi(psId);
    },
    resetPmiFilters: function() {
      for (var filter in this.pmiFiltersMap) {
        this.pmiFiltersMap[filter].psIds = [];
      }
    },
    processPmi: function(psId) {
      var nodeData = this.pmiManager.getPmiStructureInfo(psId, [], 2);
      var nodeChildren = nodeData.children;
      if (nodeChildren) {
        for (var child of nodeChildren) {
          if (child.psId.endsWith(child.name)) {
            var currentType;
            if (this.pmiFiltersMap[child.name]) {
              currentType = child.name;
            } else {
              currentType = "Other";
            }
            for (var grandChild of child.children) {
              this.pmiFiltersMap[currentType].psIds.push(grandChild.psId);
              this.pmiManager.registerSelectionChangeEventByPsId(
                grandChild.psId,
                (function(ctx, psId) {
                  return function(selectionEvent) {
                    ctx.handleSelectionChangeEvent(psId, selectionEvent);
                  };
                })(this, grandChild.psId)
              );
            }
          } else {
            this.processPmi(child.psId);
          }
        }
      }
    },
    showHideAllPmi: function() {
      if (this.showHideAllPmiText === "ShowAllPMITooltip") {
        for (var filter1 in this.pmiFiltersMap) {
          if (this.pmiFiltersMap[filter1].psIds.length > 0 && this.pmiFiltersMap[filter1].selected === true) {
            this.pmiManager.setVisibilityByPsId(this.pmiFiltersMap[filter1].psIds, true);
          }
        }
        this.showHideAllPmiIcon = "/img/toolbar/HideAllPMI.svg";
        this.showHideAllPmiText = "HideAllPMITooltip";
        this.setPmiActive(true);
      } else {
        for (var filter2 in this.pmiFiltersMap) {
          if (this.pmiFiltersMap[filter2].psIds.length > 0) {
            this.pmiManager.setVisibilityByPsId(this.pmiFiltersMap[filter2].psIds, false);
          }
        }
        this.showHideAllPmiIcon = "/img/toolbar/ShowAllPMI.svg";
        this.showHideAllPmiText = "ShowAllPMITooltip";
        this.setPmiActive(false);
      }
    },
    hideSelectedPmi: function() {
      if (this.selectedPmi) {
        var selected = this.selectedPmi;
        this.pmiManager.setSelectionByPsId(selected, false);
        this.pmiManager.setVisibilityByPsId(selected, false);
      }
    },
    alignSelectedPmi: function() {
      if (this.selectedPmi) {
        this.pmiManager.alignCameraToPmi(this.selectedPmi);
      }
    },
    openPMIFilters: function() {
      this.setSideDrawer("pmiFilters");
    },
    handleSelectionChangeEvent: function(psId, selectionEvent) {
      if (selectionEvent) {
        this.selectedPmi = psId;
      } else {
        if (this.selectedPmi === psId) {
          this.selectedPmi = "";
        }
      }
    }
  }
};
</script>

<style scoped>
.v-list-item--disabled {
  background-color: gray;
}
</style>
